const styles = () => ({
  root: {
    flex: '1 1 auto',
    display: 'flex',
    flexDirection: 'column',
    minWidth: 420,
  },

  modal: {
    zIndex: 10,
  },

  titleRow: {
    flex: 'none',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 42,
    margin: '40px',
    '& h2': {
      margin: 0,
    },
  },

  title: {
    fontSize: 30,
    color: '#414953',
    letterSpacing: '0',
    flex: '1 0 auto',
    fontWeight: 400,
    margin: '40px 40px 0 40px',
    display: 'flex',
    alignItems: 'center',
  },

  subtitle: {
    fontSize: 15,
    color: '#A9B0B8',
    letterSpacing: '0',
    flex: 'none',
    margin: '8px 40px 0 40px',
    fontWeight: 400,
  },

  stickyFooter: {
    display: 'flex',
    flex: '0 0 auto',
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#fff',
    padding: '20px 40px 20px 40px',
    borderTop: '1px solid #F3F4F5',

    ['@supports (position:sticky)']: {
      '&': {
        position: 'sticky',
        bottom: 0,
      },
    },
  },

  header: {
    padding: '40px',
  },

  divider: {
    borderTop: '1px solid #F3F4F5',
    border: 0,
    height: 1,
    width: '100%',
    margin: 0,
  },

  content: {
    flex: '1 1 auto',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    minHeight: 0,
  },

  section: {
    padding: '40px',
  },

  contentContainer: {
    width: '100%',
    flex: '1 0 auto',
    display: 'flex',
    flexDirection: 'column',
    padding: 40,
  },

  noPadding: {
    padding: 0,
  },

  close: {
    position: 'absolute',
    top: 35,
    left: -22,
    width: 44,
    height: 44,
    background: '#fafbfc',
    borderRadius: '50%',

    '&:hover': {
      background: 'white',
    },

    '&::before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      boxShadow: `0px 8px 10px -5px rgba(0, 0, 0, 0.2)`,
      zIndex: -2,
      top: 0,
      left: 0,
      width: 44,
      height: 44,
      background: '#fafbfc',
      borderRadius: '50%',
    },
  },
});

export default styles;
